import { Injectable } from '@angular/core';
import { BankingAccountItem } from './banking-account-item';
import { Observable } from 'rxjs';

import { HttpRequestService } from '../../../shared/http/http-request.service';
import {BankingAccountItemService} from './banking-account-item.service';

@Injectable()
export class BankingAccountItemSelectService extends BankingAccountItemService {}
